import { call, put, takeEvery } from "redux-saga/effects";
import axios from "axios";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, CLEAR_API_ERROR } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess, clearApiError } from "./actions";
import { useNavigate } from "react-router-dom";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
} from "../../../helpers/fakebackend_helper";

const fireBaseBackend = getFirebaseBackend();

// function* loginUser({ payload: { user, history } }) {
//   try {
//     if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
//       const response = yield call(
//         fireBaseBackend.loginUser,
//         user.email,
//         user.password
//       );
//       yield put(loginSuccess(response));
//     } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
//       const response = yield call(postJwtLogin, {
//         email: user.email,
//         password: user.password,
//       });
//       localStorage.setItem("authUser", JSON.stringify(response));
//       yield put(loginSuccess(response));
//     } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
//       const response = yield call(postFakeLogin, {
//         email: user.email,
//         password: user.password,
//       });
//       localStorage.setItem("authUser", JSON.stringify(response));
//       yield put(loginSuccess(response));
//     }
//     history("/dashboard");
//   } catch (error) {
//     yield put(apiError(error));
//   }
// }
/**
 * Generate a 16-character random token
 * @returns {string} - A randomly generated string
 */
const generateRandomToken = () => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let token = '';
  for (let i = 0; i < 16; i++) {
    token += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return token;
};
function maskToken(token) {
  // Mask all but the first and last 4 characters of the token
  const maskedToken = token.substring(0, 1) + '************' + token.slice(-1);
  return maskedToken;
}
function maskPermission(permission) {
  return "*".repeat(permission.length);
}

function* loginUser({ payload: { user, history } }) {
  try {
    // API request to real login endpoint
    //const response = yield call(axios.post, "https://qualityhub.linceducation.com/api/login/", {
      const response = yield call(axios.post, `${process.env.REACT_APP_API_BASE_URL}login/`, {
      username: user.email,
      password: user.password,

    });

    if (response.message === "Login successful") {

      const token = generateRandomToken();
      const maskedToken = maskToken(token);
      

      localStorage.setItem("name", response.name);
      localStorage.setItem("username", response.username);
      localStorage.setItem("token", maskedToken);  // Store random token
      localStorage.setItem("usertoken", response.user_token);  // Store random token
      localStorage.setItem("userpremission", response.role);
      localStorage.setItem("tabs", JSON.stringify(response.tabs));
      localStorage.setItem("uid", response.user_id);

      



      // Successful login, dispatch loginSuccess
      yield put(loginSuccess(response));
      // console.log("login", response)
      yield put(clearApiError()); // Clear error on success
      history("/dashboard"); // Redirect to dashboard
    } else {
      // Handle error if login fails
      // yield put(apiError("Invalid credentials"));
      // loginUser();
      yield put(apiError(response.error || "Invalid credentials"));

    }
  } catch (error) {
    // Handle API error
    const message =
      (error.response && error.response && error.response.error) ||
      error.message ||
      "User Name or Password Incorrect";
    yield put(apiError(message));
    // yield put(apiError(error.response.message || "Login failed"));
  }


}







function* logoutUser() {
  try {
    sessionStorage.clear();
    localStorage.removeItem("name");
    localStorage.removeItem("username");
    localStorage.removeItem("token");
    localStorage.removeItem("usertoken");
    localStorage.removeItem("userpremission");
    localStorage.removeItem("tabs");
    localStorage.removeItem("userRole");
    localStorage.removeItem("uid");







    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(fireBaseBackend.logout);
      yield put(logoutUserSuccess(LOGOUT_USER, response));
    } else {
      yield put(logoutUserSuccess(LOGOUT_USER, true));
    }
  } catch (error) {
    yield put(apiError(LOGOUT_USER, error));
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser);

  yield takeEvery(LOGOUT_USER, logoutUser);
}

export default authSaga;
